import { render, staticRenderFns } from "./auctionDetails.vue?vue&type=template&id=283a388b&scoped=true&"
import script from "./auctionDetails.vue?vue&type=script&lang=js&"
export * from "./auctionDetails.vue?vue&type=script&lang=js&"
import style0 from "./auctionDetails.vue?vue&type=style&index=0&id=283a388b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283a388b",
  null
  
)

export default component.exports